<template>
  <div class="history">
    <div class="history__title">{{ $tr('online-interview.name') }}</div>
    <div class="history__table">
      <div class="history__row history__row_head">
        <div class="history__name">
          {{ $tr('onlineInterview.room.nameInterview') }}
        </div>
        <div class="history__date">{{ $tr('onlineInterview.room.date') }}</div>
        <div class="history__time">{{ $tr('onlineInterview.room.time') }}</div>
      </div>
      <history-row
        v-for="(item, i) in history"
        :key="i"
        :class="{ active: open_preview && item.id === active_row }"
        :index="i"
        :item="item"
        :time_format="time_format"
        @set_active="set_active"
      />
    </div>

    <transition name="modal">
      <preview
        v-if="open_preview"
        :data="data"
        :time_format="time_format"
        :locale="locale"
        @close="close"
      />
    </transition>
  </div>
</template>

<script>
  import historyRow from './history_row.vue';
  import preview from './preview.vue';

  export default {
    name: 'history',

    components: {
      historyRow,
      preview
    },

    props: {
      time_format: {
        type: Number,
        default: 24
      },
      locale: {
        type: String,
        default: 'ru'
      }
    },

    data() {
      return {
        active_row: null,
        open_preview: false,
        data: null
      };
    },

    computed: {
      history() {
        return this.$store.getters['online_interview/history'];
      }
    },

    methods: {
      set_active(item) {
        this.active_row = item.id;
        this.data = item;
        this.open_preview = true;
      },

      close() {
        this.open_preview = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .history {
    margin-top: 55px;
    font-size: 15px;

    &__title {
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
      color: #233346;
      margin-bottom: 30px;
    }

    &__row {
      display: flex;
      align-items: center;

      &_head {
        margin-bottom: 14px;
        font-weight: 300;
        line-height: 22px;
        letter-spacing: 0.005em;
        padding: 0 19px;
        color: #233346;
      }
    }

    &__name {
      width: 550px;

      span {
        display: inline-block;
        cursor: pointer;
      }
    }

    &__date {
      width: 180px;
    }

    &__time {
      width: 275px;
    }

    &__room {
      margin-left: 40px;
      cursor: pointer;
    }
  }
</style>
